import { render, staticRenderFns } from "./VaccinesIcon.vue?vue&type=template&id=301fd10a&"
import script from "./VaccinesIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VaccinesIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports